import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "categories-filter__icon-box" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "categories-filter__name" }

import { computed } from 'vue'
import type { DocsTagsView as CategoriesView } from '@/models/docs.tags'


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryItem',
  props: {
    tag: {},
    view: {},
    isMobile: { type: Boolean, default: false },
    itemIndex: { default: 0 }
  },
  setup(__props: any) {

const props = __props

const showItem = computed(() => {
  if (props.isMobile) {
    return true
  }

  return props.view.showAllTags || props.itemIndex < 6
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (showItem.value)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.view.getUrl(__props.tag),
        class: "categories-filter__item"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              class: "categories-filter__icon",
              src: __props.view.tagIcon(__props.tag),
              alt: __props.tag
            }, null, 8, _hoisted_2)
          ]),
          _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.tag), 1)
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})